import { ModalLayout, Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { Send } from 'lucide-react';

/**
 * Approve-and-send confirmation for HTL / Client Continuation. Names the output
 * and recipient and shows the draft read-only — revising it happens inline in the
 * detail body ("Edit then send"), not here. Confirm delegates to `onConfirm`
 * (CT-5096: the parent footer runs POST /v1/tasks/hitl/resolve and owns the toast
 * + close), so the modal stays open on failure to retry.
 */
function ApproveSendModal({ isOpen, event, onClose, onConfirm, isSubmitting = false }) {
  const { t } = useTranslation('work-queues-app');
  const output = event?.detail?.output ?? {};

  if (!isOpen) return null;

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      useBodyPortal
      titlePrefix={<Send size={20} className="text-emerald-500" />}
      breadcrumb={event ? `${event.id} · ${event.refLabel ?? ''}` : undefined}
      title={t('continuation.approveTitle')}
      subtitle={t('continuation.approveSubtitle', { recipient: output.recipient ?? '' })}
    >
      <div className="flex flex-col gap-3 px-6 py-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-content-muted">{t('continuation.channel')}</span>
          <span className="font-medium text-content">{output.channel}</span>
        </div>
        <pre className="whitespace-pre-wrap rounded-lg border border-edge bg-surface-muted px-4 py-3 font-sans text-sm text-content-secondary">
          {output.draft}
        </pre>
      </div>

      <div className="flex justify-end gap-2 border-t border-edge px-6 py-4">
        <Button variant="secondary" size="sm" disabled={isSubmitting} onClick={onClose}>
          {t('actions.cancel')}
        </Button>
        <Button variant="primary" size="sm" disabled={isSubmitting} onClick={onConfirm}>
          {isSubmitting ? t('hitl.resolving') : t('continuation.approveSend')}
        </Button>
      </div>
    </ModalLayout>
  );
}

export default ApproveSendModal;
